export const axiosConfig = {
	headers: {
		authorization: null
	},
	timeout: 5000
}